// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-public-audit .audit-tips {\n  padding: 20px 0 40px;\n}\n", ""]);
// Exports
module.exports = exports;
